import { relativeTime } from '@/utils/date'
import { useWireState } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import SettingsWrapper from './SettingsWrapper'

const History = () => {
    
    const [viewedDocuments, setViewedDocuments] = useWireState(store.viewedDocuments)
    
    const sortedDocs = useMemo(() => (
        Object.values(viewedDocuments).sort((a, b) => (
            a.collectionName?.localeCompare(b.collectionName)
        ))
    ), [viewedDocuments])
    
    return ( 
        <SettingsWrapper title="History" buttonLabel="Clear History" onClick={() => setViewedDocuments({})}> 
            <div className="divide-y divide-slate-50/25 text-white">
                <div>
                    {/* 
                <div className="flex justify-end">
                </div>
                I DONT KNOW WHY THIS DIV EXISTS. I THINK IT DOES NOTHING.
                */}
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Document</th>
                                <th>Collection</th>
                                <th>Last Viewed</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sortedDocs.map(doc => (
                                <tr key={doc.id}>
                                    <td><Link
                                        onClick={() => actions.addDocumentToHistory(doc)}
                                        target="_blank"
                                        rel="noreferrer"
                                        to={`/edit/${doc.id}`}>
                                        {doc.name}
                                    </Link>
                                    </td>
                                    <td>{doc.collectionName}</td>
                                    <td>{relativeTime(doc.viewedAt)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        
        </SettingsWrapper>
        
    )
}

export default History
